import { Box, Button, Typography } from '@mui/material';
import { updateStateObjectData } from '../../../utility/Common';
import MetadataEditableField from './MetadataEditableField';
import { MetadataSelectField } from './MetadataSelectField';

const EntityEssentialInfo = ({ editableEntityData, setEditableEntityData, global_constant, createQuestions }) => {
    return (
        <>
            {editableEntityData?._id &&
                (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mb: 1 }}>
                        <Typography fontWeight="bold" sx={{ fontSize: 14, color: 'black', alignSelf: 'flex-start', mb: 1 }}>{`ID : ${editableEntityData?._id}` || 'Create Entity'}</Typography>
                        {/* <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: '#ffe987ff',
                                color: 'black',
                                fontWeight: 'bold',
                                '&:hover': {
                                    backgroundColor: '#fdd835',
                                },
                            }}
                            onClick={() => {
                                console.log("Create Question clicked!");
                                createQuestions(editableEntityData)
                            }}
                        >
                            Create Question
                        </Button> */}
                    </Box>
                )}

            <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>

                <MetadataEditableField
                    isFullWidth={true}
                    label={"Entity Name"}
                    value={editableEntityData?.displayName}
                    onChange={(value) => {
                        updateStateObjectData(editableEntityData, setEditableEntityData, "displayName", value)
                    }}
                />

                <MetadataSelectField
                    label="Entity Type"
                    value={editableEntityData?.type?.toLowerCase()}
                    onChange={(value) => {
                        updateStateObjectData(editableEntityData, setEditableEntityData, "type", value)
                    }
                    }
                    options={global_constant?.EntertainmentEntityTypesV2}
                />

            </Box>
        </>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default EntityEssentialInfo
